import React from 'react';

export const CheckedProspectPoolsContext = React.createContext<{
  checkedProspectPoolIds: string[];
  setCheckedProspectPoolIds: React.Dispatch<React.SetStateAction<string[]>>;
}>(null);
